import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import App from "./App";
import Rekap from "./pages/Rekap";
import Test from "./pages/Test";
import Login from "./pages/Login";
import Visualisasi from "./pages/Visualisasi";
import PrivateRoute from "./components/PrivateRoute";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<PrivateRoute />}>
          <Route path="/" element={<App />} />
          <Route path="/rekap" element={<Rekap />} />
          <Route path="/test" element={<Test />} />
          <Route path="/visualisasi" element={<Visualisasi />} />
        </Route>
        <Route path="/login" element={<Login />} />
      </Routes>
    </Router>
  </React.StrictMode>
);
